import React, { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { LanguageContext } from "@/App";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const TempleDetail = () => {
  const { id } = useParams();
  const { language } = useContext(LanguageContext);

  const templesData = {
    "jay-taleti": {
      name: "Sri Jay Taleti",
      nameHi: "श्री जय तलेटी",
      img: "https://static.wixstatic.com/media/4365ca_1258e0b08f274c79a07b3f2843068e73~mv2.png",
      description:
        "Sri Jay Taleti is a sacred pilgrimage site with profound spiritual significance in the Jain community. This temple is renowned for its serene atmosphere and is a place where devotees come to seek blessings and inner peace.",
      descriptionHi:
        "श्री जय तलेटी जैन समुदाय में गहरे आध्यात्मिक महत्व के साथ एक पवित्र तीर्थ स्थल है। यह मंदिर अपने शांत वातावरण के लिए प्रसिद्ध है।",
    },
    "girnar-tunk": {
      name: "Sri Girnar Tunk",
      nameHi: "श्री गिरनार टूंक",
      img: "https://static.wixstatic.com/media/4365ca_f45e65c17f3047e891a809c561130ace~mv2.png",
      description:
        "Sri Girnar Tunk represents the glory of Mount Girnar, one of the most sacred pilgrimage sites in Jainism. This temple recreates the divine experience of the holy Girnar pilgrimage.",
      descriptionHi:
        "श्री गिरनार टूंक गिरनार पर्वत की महिमा का प्रतिनिधित्व करता है, जो जैन धर्म में सबसे पवित्र तीर्थ स्थलों में से एक है।",
    },
    varshitap: {
      name: "Sri Varshitap Mandir",
      nameHi: "श्री वर्षितप मंदिर",
      img: "https://static.wixstatic.com/media/4365ca_cbaff8dc125048b6b7d8cd248d5cba92~mv2.png",
      description:
        "Sri Varshitap Mandir is dedicated to Varshitap, symbolizing devotion and penance. This temple inspires devotees to follow the path of righteousness and spiritual discipline.",
      descriptionHi:
        "श्री वर्षितप मंदिर वर्षितप को समर्पित है, जो भक्ति और तपस्या का प्रतीक है।",
    },
    adinath: {
      name: "Sri Adinath Bhagwan Main Mandir",
      nameHi: "श्री आदिनाथ भगवान मुख्य मंदिर",
      img: "https://static.wixstatic.com/media/4365ca_bb83f89730b8417bb60bcea35f53f61e~mv2.png",
      description:
        "The main temple dedicated to Lord Adinath (Rishabhanatha), the first Tirthankara in Jainism. This magnificent temple is the spiritual heart of the Teerth Dham, featuring beautiful architecture and divine sanctity.",
      descriptionHi:
        "पहले तीर्थंकर भगवान आदिनाथ (ऋषभदेव) को समर्पित मुख्य मंदिर। यह भव्य मंदिर तीर्थ धाम का आध्यात्मिक हृदय है।",
    },
    ghetipag: {
      name: "Sri Ghetipag Mandir",
      nameHi: "श्री घेटीपाग मंदिर",
      img: "https://static.wixstatic.com/media/4365ca_16fd2e4343254440b2ad87cb161cc158~mv2.png",
      description:
        "Sri Ghetipag Mandir is a revered temple known for its unique architectural beauty and spiritual ambiance. It attracts devotees seeking divine blessings and peace.",
      descriptionHi:
        "श्री घेटीपाग मंदिर अपनी अद्वितीय वास्तुकला सुंदरता और आध्यात्मिक वातावरण के लिए जाना जाता है।",
    },
    labhdhi: {
      name: "Sri Labhdhi Dadawadi - Dev Devi Mandir",
      nameHi: "श्री लाभधि दाडावाडी - देव देवी मंदिर",
      img: "https://static.wixstatic.com/media/4365ca_76c89b072465419b9ff41f8dcef34acb~mv2.png",
      description:
        "This temple is dedicated to Dev and Devi deities, serving as a center for worship and spiritual practices. It is an important part of the Teerth Dham complex.",
      descriptionHi:
        "यह मंदिर देव और देवी देवताओं को समर्पित है और पूजा और आध्यात्मिक अभ्यास के केंद्र के रूप में कार्य करता है।",
    },
    "motisa-tunk": {
      name: "Sri Motisa Tunk",
      nameHi: "श्री मोटिसा टूंक",
      img: "https://static.wixstatic.com/media/4365ca_600c1e43f90e4cf2815079a2c8eb3a49~mv2.png",
      description:
        "Sri Motisa Tunk is a significant spiritual landmark in the Teerth Dham, offering a tranquil environment for meditation and prayer.",
      descriptionHi:
        "श्री मोटिसा टूंक तीर्थ धाम में एक महत्वपूर्ण आध्यात्मिक स्थलचिह्न है।",
    },
    upcoming: {
      name: "Other Upcoming Projects",
      nameHi: "अन्य आगामी परियोजनाएं",
      img: "https://static.wixstatic.com/media/4365ca_594cdafb37794153a6b5f1a82fe059de~mv2.png",
      description:
        "We are working on exciting new spiritual developments that will further enhance the divine experience at Sri Siddhachal Sthulabhadra dham. Stay tuned for more updates on our upcoming projects.",
      descriptionHi:
        "हम रोमांचक नए आध्यात्मिक विकास पर काम कर रहे हैं जो श्री सिद्धाचल स्थूलभद्र धाम में दिव्य अनुभव को और बढ़ाएंगे।",
    },
  };

  const temple = templesData[id];

  const content = {
    en: {
      back: "Back to Divine Attractions",
    },
    hi: {
      back: "दिव्य आकर्षण पर वापस जाएं",
    },
  };

  if (!temple) {
    return (
      <div className="container mx-auto px-4 py-20 text-center">
        <h1 className="text-3xl font-bold text-amber-900">Temple not found</h1>
        <Link to="/divine-attractions" className="mt-4 inline-block">
          <Button>{content[language].back}</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      {/* Back Button */}
      <div className="container mx-auto px-4 py-6">
        <Link to="/divine-attractions">
          <Button
            variant="outline"
            className="border-amber-600 text-amber-700 hover:bg-amber-50"
            data-testid="back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" /> {content[language].back}
          </Button>
        </Link>
      </div>

      {/* Temple Detail */}
      <section className="py-8 px-4 bg-white">
        <div className="container mx-auto max-w-5xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Image */}
            <div
              className="rounded-2xl overflow-hidden shadow-2xl"
              data-testid="temple-image"
            >
              <img
                src={temple.img}
                alt={language === "en" ? temple.name : temple.nameHi}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content */}
            <div>
              <h1
                className="text-4xl sm:text-5xl font-bold gradient-text mb-6"
                data-testid="temple-name"
              >
                {language === "en" ? temple.name : temple.nameHi}
              </h1>
              <p
                className="text-base md:text-lg text-amber-800 leading-relaxed"
                data-testid="temple-description"
              >
                {language === "en" ? temple.description : temple.descriptionHi}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TempleDetail;
